import { gql } from '@apollo/client';
import parse from 'html-react-parser';
import { useMemo } from 'react';

const GET_CATEGORY_CONTENT = gql`
  query getCategoryData($id: String!) {
    categories(filters: { category_uid: { in: [$id] } }) {
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      items {
        id
        uid
        name
        description
        url_key
        url_path
        category_image
        category_image_m
        meta_title
      }
    }
  }
`;

export const useGetCategoryDescription = ({ categoryData }: { categoryData: any }) => {
  // const { data: categoryData, loading: categoryLoading } = useQuery(GET_CATEGORY_CONTENT, {
  //   fetchPolicy: 'cache-and-network',
  //   nextFetchPolicy: 'cache-first',
  //   skip: !categoryId,
  //   variables: {
  //     id: categoryId,
  //   },
  // });
  const category_image =
    categoryData && categoryData.categories.items.length ? categoryData.categories.items[0].category_image : null;
  const category_image_m =
    categoryData && categoryData.categories.items.length ? categoryData.categories.items[0].category_image_m : null;
  const meta_title =
    categoryData && categoryData.categories.items.length ? categoryData.categories.items[0].meta_title : null;
  const categoryName =
    categoryData && categoryData.categories.items.length ? categoryData.categories.items[0].name : null;

  const originalCategoryDescription =
    categoryData && categoryData.categories.items.length ? categoryData.categories.items[0].description : null;

  const categoryDescription =
    originalCategoryDescription &&
    originalCategoryDescription.indexOf(
      '<div data-content-type="html" data-appearance="default" data-element="main">',
    ) > -1
      ? originalCategoryDescription
          .replaceAll('<div data-content-type="html" data-appearance="default" data-element="main">', '')
          .replaceAll('</div>', '')
          .replaceAll('&gt;', '>')
          .replaceAll('&lt;', '<')
          .replaceAll('&amp;', '&')
      : originalCategoryDescription;

  const mobileCategoryDescriptionTitle = useMemo(() => {
    let title = '';

    if (categoryDescription) {
      const parsedCategoryDescription = parse(categoryDescription) as any[];

      Object.prototype.toString.call(parsedCategoryDescription) === '[object Array]' &&
        parsedCategoryDescription?.forEach((temp: any) => {
          if (temp.type === 'h2') {
            title = temp;
          }
        });

      return title;
    }
  }, [categoryDescription]);

  return {
    categoryDescription,
    mobileCategoryDescriptionTitle,
    categoryName,
    meta_title,
    category_image,
    category_image_m,
  };
};
